import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/js/src/collapse.js";

import "mdb-react-ui-kit/dist/css/mdb.min.css";
import { Route, Routes, useLocation } from "react-router-dom";
import MyProfile from "../MyProfile/MyProfile";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './toast.colors.module.scss';
import { ExternalRegister } from "../ExternalRegister/ExternalRegister";
import ProtectedRoutes from "../../components/ProtectedRoutes/ProtectedRoutes";
import { VerifyEmail } from "../VerifyEmail/VerifyEmail";
import { useEffect } from "react";
import { getApm } from "../../core/providers/apm.provider";
import { ChangePassword } from "../ChangePassword/ChangePassword";
import { ChangeRecoveryEmail } from "../ChangeRecoveryEmail/ChangeRecoveryEmail";
import PasswordResetLinkSent from "../PasswordResetLinkSent/PasswordResetLinkSent";

export default function App() {
  const location = useLocation();

  useEffect(() => {
    const apm = getApm();
    if (!apm?.isActive?.()) return;

    const url = `${location.pathname}${location.search}${location.hash}`;
    const transaction = apm.startTransaction(`Route: ${url}`, "route-change");
    transaction?.addLabels?.({
      route: url,
    });

    setTimeout(() => transaction?.end?.(), 100);
  }, [location]);

  return (
    <>
      <ToastContainer hideProgressBar={true} theme="colored" icon={""} autoClose={3000} />
      <Routes>
        <Route
          path="/:pool_id/:pool_tenant/password-reset-link-sent"
          element={<PasswordResetLinkSent />}
        />
        <Route path='/:pool_id/:pool_tenant' element={<ProtectedRoutes />}>
          <Route element={<MyProfile />} index />
        </Route>
        <Route path="/*" element={<ProtectedRoutes />} >
          <Route element={<MyProfile />} index />
        </Route>
        <Route path="register" element={<ExternalRegister />} />
        <Route path="verify" element={<VerifyEmail />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="change-recovery-email" element={<ChangeRecoveryEmail />} />
      </Routes>
    </>
  );
}
